<!-- Other CF Charges Card -->
<div class="card">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center position-relative my-1">
        <h3 class="fw-bold me-5 my-1">Other CF Charges</h3>
      </div>
    </div>
  </div>

  <div class="card-body pt-0">
    <form [formGroup]="otherCfChargesForm" (ngSubmit)="onSubmit()" novalidate>

      <!-- Custom Depending on M3 Section -->
      <div class="row mb-8">
        <div class="col-12">
          <h4 class="fw-bold mb-5">Custom Depending on M3</h4>

          <div class="table-responsive">
            <table class="table table-bordered align-middle">
              <thead class="bg-light">
                <tr>
                  <th class="text-center fw-bold">From</th>
                  <th class="text-center fw-bold">To</th>
                  <th class="text-center fw-bold">Amount</th>
                  <th class="text-center fw-bold">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of customDependingM3Items; let i = index">
                  <td>
                    <input
                      type="number"
                      class="form-control form-control-solid text-center"
                      [(ngModel)]="item.from"
                      [ngModelOptions]="{standalone: true}"
                      placeholder="0"
                      min="0"
                      step="0.01"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      class="form-control form-control-solid text-center"
                      [(ngModel)]="item.to"
                      [ngModelOptions]="{standalone: true}"
                      placeholder="0"
                      min="0"
                      step="0.01"
                    />
                  </td>
                  <td>
                    <div class="input-group">
                      <input
                        type="number"
                        class="form-control form-control-solid text-end"
                        [(ngModel)]="item.amount"
                        [ngModelOptions]="{standalone: true}"
                        placeholder="0"
                        min="0"
                        step="0.01"
                      />
                      <span class="input-group-text">JPY</span>
                    </div>
                  </td>
                  <td class="text-center">
                    <button
                      type="button"
                      class="btn btn-sm btn-light-danger me-2"
                      (click)="removeCustomDependingM3Item(i)"
                      *ngIf="customDependingM3Items.length > 1"
                    >
                      <i class="ki-solid ki-trash fs-5"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <button
              type="button"
              class="btn btn-sm btn-primary"
              (click)="addCustomDependingM3Item()"
            >
              <i class="ki-duotone ki-plus fs-2"></i> Add More
            </button>
          </div>
        </div>
      </div>

      <!-- ISL Commission Section -->
      <div class="row mb-8">
        <div class="col-12">
          <h4 class="fw-bold mb-5">ISL Commission</h4>

          <div class="table-responsive">
            <table class="table table-bordered align-middle">
              <thead class="bg-light">
                <tr>
                  <th class="text-center fw-bold">From</th>
                  <th class="text-center fw-bold">To</th>
                  <th class="text-center fw-bold">Type</th>
                  <th class="text-center fw-bold">Amount</th>
                  <th class="text-center fw-bold">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of islCommissionItems; let i = index">
                  <td>
                    <input
                      type="number"
                      class="form-control form-control-solid text-center"
                      [(ngModel)]="item.from"
                      [ngModelOptions]="{standalone: true}"
                      placeholder="0"
                      min="0"
                      step="0.01"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      class="form-control form-control-solid text-center"
                      [(ngModel)]="item.to"
                      [ngModelOptions]="{standalone: true}"
                      placeholder="0"
                      min="0"
                      step="0.01"
                    />
                  </td>
                  <td>
                    <select
                      class="form-select form-select-solid"
                      [(ngModel)]="item.type"
                      [ngModelOptions]="{standalone: true}"
                    >
                      <option value="percentage">Percentage</option>
                      <option value="fixed">Fixed</option>
                    </select>
                  </td>
                  <td>
                    <div class="input-group">
                      <input
                        type="number"
                        class="form-control form-control-solid text-end"
                        [(ngModel)]="item.amount"
                        [ngModelOptions]="{standalone: true}"
                        placeholder="0"
                        [min]="getAmountMin(item)"
                        [max]="getAmountMax(item)"
                        step="0.01"
                      />
                      <span class="input-group-text">{{ getAmountLabel(item) }}</span>
                    </div>
                  </td>
                  <td class="text-center">
                    <button
                      type="button"
                      class="btn btn-sm btn-light-danger me-2"
                      (click)="removeIslCommissionItem(i)"
                      *ngIf="islCommissionItems.length > 1"
                    >
                      <i class="ki-solid ki-trash fs-5"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-end mt-3">
            <button
              type="button"
              class="btn btn-sm btn-primary"
              (click)="addIslCommissionItem()"
            >
              <i class="ki-duotone ki-plus fs-2"></i> Add More
            </button>
          </div>
        </div>
      </div>

      <!-- Static Fields Section -->
      <div class="row mb-8">
        <div class="col-12">
          <h4 class="fw-bold mb-5">Other Charges</h4>

          <div class="row">
            <!-- Car Tax Avg -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Car Tax Avg.</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control form-control-solid"
                  formControlName="car_tax_avg"
                  placeholder="Enter amount"
                  min="0"
                  step="0.01"
                  [class.is-invalid]="carTaxAvg?.invalid && carTaxAvg?.touched"
                />
                <span class="input-group-text">JPY</span>
              </div>
              <div *ngIf="carTaxAvg?.invalid && carTaxAvg?.touched" class="invalid-feedback d-block">
                <div *ngIf="carTaxAvg?.errors?.['min']">Amount must be 0 or greater</div>
              </div>
            </div>

            <!-- Recycle Fee -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Recycle Fee</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control form-control-solid"
                  formControlName="recycle_fee"
                  placeholder="Enter amount"
                  min="0"
                  step="0.01"
                  [class.is-invalid]="recycleFee?.invalid && recycleFee?.touched"
                />
                <span class="input-group-text">JPY</span>
              </div>
              <div *ngIf="recycleFee?.invalid && recycleFee?.touched" class="invalid-feedback d-block">
                <div *ngIf="recycleFee?.errors?.['min']">Amount must be 0 or greater</div>
              </div>
            </div>

            <!-- Insurance IF -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Insurance . IF</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control form-control-solid"
                  formControlName="insurance_if"
                  placeholder="Enter amount"
                  min="0"
                  step="0.01"
                  [class.is-invalid]="insuranceIf?.invalid && insuranceIf?.touched"
                />
                <span class="input-group-text">JPY</span>
              </div>
              <div *ngIf="insuranceIf?.invalid && insuranceIf?.touched" class="invalid-feedback d-block">
                <div *ngIf="insuranceIf?.errors?.['min']">Amount must be 0 or greater</div>
              </div>
            </div>

            <!-- Other IF -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Other . IF</label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control form-control-solid"
                  formControlName="other_if"
                  placeholder="Enter amount"
                  min="0"
                  step="0.01"
                  [class.is-invalid]="otherIf?.invalid && otherIf?.touched"
                />
                <span class="input-group-text">JPY</span>
              </div>
              <div *ngIf="otherIf?.invalid && otherIf?.touched" class="invalid-feedback d-block">
                <div *ngIf="otherIf?.errors?.['min']">Amount must be 0 or greater</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-end">
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="isLoading"
            >
              <span *ngIf="isLoading" class="indicator-progress">
                Please wait...
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
              <span *ngIf="!isLoading" class="indicator-label">Update</span>
            </button>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>
